import React from "react";
import { IMAGES } from "@/lib/config";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

const VALUES = [
  "Meticulous craftsmanship",
  "Insured &amp; punctual",
  "Honest, itemized estimates",
  "Clean job sites, every day",
  "Warranty on our workmanship",
];

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
      <div className="grid md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-5">
          <div className="eyebrow text-[color:var(--brand-wood)]">About JFeva Solutions, LLC</div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Family-run craftsmen for floors &amp; tile.
          </h1>
          <p className="mt-6 text-[color:var(--brand-woodDark)] leading-relaxed">
            Founded and led by owner <span className="text-[color:var(--brand-ink)] font-medium">Corwin Calloway</span>, JFeva Solutions, LLC was built on a simple idea: your floor should look better a decade from now than the day it was installed. We take on flooring, tile installation, repairs, and custom design work across
            Florida and neighboring areas — treating every job like our own home.
          </p>
          <p className="mt-4 text-[color:var(--brand-woodDark)] leading-relaxed">
            From measure to grout, we don&apos;t cut corners. That&apos;s how our clients become referrals — and how
            we&apos;ve earned our motto:
          </p>
          <p className="mt-4 font-display italic text-2xl">&ldquo;Our quality will floor you.&rdquo;</p>

          <ul className="mt-8 space-y-3">
            {VALUES.map((v) => (
              <li key={v} className="flex items-start gap-3 text-sm">
                <CheckCircle2 className="h-5 w-5 text-[color:var(--brand-forest)] mt-0.5" />
                <span dangerouslySetInnerHTML={{ __html: v }} />
              </li>
            ))}
          </ul>

          <div className="mt-10 flex gap-3">
            <Link
              data-testid="about-quote-btn"
              to="/quote"
              className="inline-flex items-center rounded-full bg-[color:var(--brand-ink)] text-[color:var(--brand-cream)] px-6 py-3 text-sm hover:-translate-y-0.5 transition-transform"
            >
              Request a Quote
            </Link>
            <Link
              data-testid="about-services-btn"
              to="/services"
              className="inline-flex items-center rounded-full border border-black/15 px-6 py-3 text-sm hover:bg-black/5 transition-colors"
            >
              See Services
            </Link>
          </div>
        </div>

        <div className="md:col-span-7 grid grid-cols-2 gap-4">
          <img src={IMAGES.about} alt="Craftsman tools" className="rounded-2xl object-cover aspect-[4/5] w-full"/>
          <div className="space-y-4">
            <img src={IMAGES.custom} alt="Custom tile" className="rounded-2xl object-cover aspect-square w-full"/>
            <img src={IMAGES.repair} alt="Floor repair" className="rounded-2xl object-cover aspect-square w-full"/>
          </div>
        </div>
      </div>
    </div>
  );
}
